// src/pages/admin/AdminDashboard.js
import React, { useState } from 'react';
import '../../../assets/css/admin/AdminDashboard.css';
import AdminLayout from '../../../layouts/admin/adminlayout/AdminLayout';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');

  // Stats Data
  const stats = [
    {
      id: 1,
      title: 'Total Users',
      value: '5',
      change: '+12.5%',
      changeType: 'increase',
      icon: '👥',
      color: 'blue'
    },
    {
      id: 2,
      title: 'Study Groups',
      value: '7',
      change: '+8.2%',
      changeType: 'increase',
      icon: '👨‍👩‍👧‍👦',
      color: 'green'
    },
    {
      id: 3,
      title: 'Active Sessions',
      value: '5',
      change: '-3.1%',
      changeType: 'decrease',
      icon: '🎥',
      color: 'purple'
    },
    {
      id: 4,
      title: 'Total Revenue',
      value: '5000',
      change: '+15.3%',
      changeType: 'increase',
      icon: '💰',
      color: 'orange'
    }
  ];

  // Quick Actions - Only 3 actions (removed Add User)
  const quickActions = [
    { id: 2, path: "/admin-study-groups", title: 'New Group', icon: '➕👥', description: 'Create study group' },
    { id: 3, path: "/files-And-Notes", title: 'Upload Content', icon: '📤', description: 'Add notes or files' },
    { id: 4, path: "/study-sessions", title: 'Start Session', icon: '🎥', description: 'Begin live session' }
  ];

  return (
    <AdminLayout>
      <div className="admin-dashboard">
        {/* Page Header */}
        <div className="page-header">
          <div className="page-header-top">
            <div className="page-title">
              <div className="page-title-icon">📊</div>
              <div>
                <h1>Dashboard</h1>
                <p className="page-description">Welcome back, Admin! Here's what's happening today.</p>
              </div>
            </div>
            <div className="page-actions">
              <button className="btn btn-secondary">
                <span>📥</span>
                Export Report
              </button>
              <button className="btn btn-primary">
                <span>➕</span>
                Add New
              </button>
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="stats-grid">
          {stats.map((stat) => (
            <div key={stat.id} className={`stat-card stat-${stat.color}`}>
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-content">
                <div className="stat-label">{stat.title}</div>
                <div className="stat-value">{stat.value}</div>
                <div className={`stat-change ${stat.changeType}`}>
                  <span className="change-icon">
                    {stat.changeType === 'increase' ? '↗' : '↘'}
                  </span>
                  <span className="change-text">{stat.change} from last month</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quick Actions - Now only 3 cards */}
        <div className="quick-actions-section">
          <h2 className="section-title-main">QUICK ACTIONS</h2>
          <div className="quick-actions-grid">
            {quickActions.map((action) => (
              <Link to={action.path}>
                <div key={action.id} className="quick-action-card">
                  <div className="quick-action-icon">{action.icon}</div>
                  <div className="quick-action-title">{action.title}</div>
                  <div className="quick-action-description">{action.description}</div>
                </div>
              </Link>

            ))}
          </div>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;